import { ANSWER_OPTIONS } from './constants';

export const calcPercentage = (value, total) => {
  return (value * 100 / total).toFixed(1);
};

// Maps the letters extracted from the answer sheet photo (ordered by question number)
// into { [questionId]: optionId }, skipping unknown letters.
// Never produces BLANK_ANSWER: blank answers must be marked manually by the user.
export const mapExtractedAnswers = (extractedAnswers, answerKey) => {
  const sortedQuestions = [...answerKey].sort((a, b) => a.questionNumber - b.questionNumber);
  return sortedQuestions.reduce((acc, question, idx) => {
    const optionIndex = ANSWER_OPTIONS.indexOf(extractedAnswers[idx]);
    const option = optionIndex >= 0 ? (question.options || [])[optionIndex] : null;
    if (option) acc[question.questionId] = option.id;
    return acc;
  }, {});
};
